angular
    .module('MW.ContactManager.ContactDomainModelConverter', [
        'MW.ContactManager.ContactManagerPropertyTypeService'
    ])
    .factory('ContactDomainModelConverter', [
        'activeOnTypes',
        'FairhairChannelTypes',
        'FairhairSocialProfileTypes',
        function(activeOnTypes,
                 FairhairChannelTypes,
                 FairhairSocialProfileTypes
        ) {
            'use strict';

            return {
                convertToDomainModel: function convertToDomainModel(contact, companyId) {
                // Convert channels from View to Domain types
                    if(contact.channels) {
                        var domainChannels = [],
                            domainSources = [];

                        contact.channels.forEach(function(channel) {
                            var domainChannel = {};

                            switch(channel.type) {
                                case activeOnTypes.BLOG:
                                    domainChannel = channel;
                                    domainChannel.type = FairhairChannelTypes.WEBSITE;

                                    break;
                                case activeOnTypes.FACEBOOK:
                                    domainChannel = {
                                        type: FairhairChannelTypes.SOCIAL,
                                        socialProfile: {
                                            type: FairhairSocialProfileTypes.FACEBOOK,
                                            userName: channel.userName,
                                            url: channel.url
                                        }
                                    };

                                    break;
                                case activeOnTypes.TWITTER:
                                    domainChannel = {
                                        type: FairhairChannelTypes.SOCIAL,
                                        socialProfile: {
                                            type: FairhairSocialProfileTypes.TWITTER,
                                            userName: channel.userName,
                                            url: channel.url
                                        }
                                    };

                                    break;
                                case activeOnTypes.LINKED_IN:
                                    domainChannel = {
                                        type: FairhairChannelTypes.SOCIAL,
                                        socialProfile: {
                                            type: FairhairSocialProfileTypes.LINKED_IN,
                                            userName: channel.userName,
                                            url: channel.url
                                        }
                                    };
                                    break;

                                case activeOnTypes.SOURCE:
                                    if (channel.source) {
                                        domainSources.push(channel.source.source || { name: channel.source });
                                    }

                                    break;

                                default:
                                    break;
                            }

                            if(Object.keys(domainChannel).length) {
                                domainChannels.push(domainChannel);
                            }
                        }, contact);

                        contact.channels = domainChannels;
                        if (domainSources.length) {
                            contact.sources = domainSources;
                        }

                    } else {
                        contact.channels = [];
                    }

                    return {
                        id: contact.id,
                        companyId: companyId,
                        name: contact.name,
                        title: contact.title,
                        contactInfo: {
                            email: contact.contactInfo.email,
                            phone: contact.contactInfo.phone,
                            addresses: contact.contactInfo.address
                        },
                        notes: contact.notes,
                        channels: contact.channels,
                        mediaLists: contact.mediaLists,
                        sources: contact.sources
                    };
                }
            };
        }
    ]);
